import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { DeleteCheckResponse } from '@src/app/shared/backend/clients';
@Component({
    selector: 'dialog-reason',
    templateUrl: './dialog-reason.component.html',
    styleUrls: ['./dialog-reason.component.scss'],
    host: {
        class: 'dialog-reason'
    },
    standalone: false
})
export class DialogReasonComponent implements OnInit {
  @Input() title: string = '';
  @Output() onClose = new EventEmitter<boolean>();

  public reason: string = '';
  public deleteCheckResponses: DeleteCheckResponse[] | undefined;

  constructor(
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void { }

  public get canDelete(): boolean {
    if (!this.deleteCheckResponses) {
      return true;
    }

    return this.deleteCheckResponses.length > 0 && this.deleteCheckResponses.every(
      response => response.canDelete === true
    );
  }

  public get hasRelationships(): boolean {
    if (!this.deleteCheckResponses) {
      return false;
    }

    for (const deleteCheckResponse of this.deleteCheckResponses) {
      const relationships = deleteCheckResponse.relationships;

      if (relationships && relationships.length > 0) {
        return true;
      }
    }

    return false;
  }

  public show(deleteCheckResponses?: DeleteCheckResponse[]): void {
    this.onHideAction();
    this.deleteCheckResponses = deleteCheckResponses;

    this.confirmationService.confirm({
      key: 'confirm-delete-dialog',
      header: this.translate.instant(this.title)
    });
  }

  public onCancel(): void {
    this.confirmationService.close();
    this.onHideAction();
    this.onClose.emit(false);
  }

  public onConfirm(): void {
    this.confirmationService.close();
    this.onHideAction();
    this.onClose.emit(true);
  }

  onHideAction(): void {
    this.reason = '';
    this.deleteCheckResponses = undefined;
  }
}
